import axiosClient from "../common/axios_client";

class Api {
  static showUser(name) {
    return axiosClient.get(`/api/v1/users/${name}`).then((response) => {
      return response.data;
    });
  }

  static appendFormData(formData, data, parentKey = '') {
    if (data && typeof data === 'object' && !(data instanceof File)) {
      Object.keys(data).forEach((key) => {
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;
        this.appendFormData(formData, data[key], fullKey);
      });
    } else {
      formData.append(parentKey, data);
    }
  }

  static updateUser (user) {
    const formData = new FormData();
    if (user.image != null) {
      formData.append('user[image]', user.image);
    }
    if (user.profile != null) {
      this.appendFormData(formData, user.profile, 'user[profile_attributes]');
    }
    if (user.angel != null) {
      this.appendFormData(formData, user.angel, 'user[angel_attributes]');
    }
    if (user.related_links != null) {
      this.appendFormData(
        formData,
        user.related_links,
        'user[related_links_attributes]'
      );
    }
    return axiosClient
      .patch(`/api/v1/users/${user.name}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }

  static showCompanies(name) {
    return axiosClient
      .get(`/api/v1/companies/autocomplete?term=${name}`)
      .then((response) => {
        return response.data;
      });
  }

  static addCareer(data) {
    return axiosClient
      .post(
        '/api/v1/careers',
        JSON.stringify({
          company: data.company,
          career: data.career,
        })
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }

  static updateCareer(career) {
    return axiosClient
      .patch(`/api/v1/careers/${career.id}`, career)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }

  static deleteCareer(career) {
    return axiosClient
      .delete(`/api/v1/careers/${career.id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }

  static addInvestment(company) {
    return axiosClient
      .post(
        '/api/v1/investments',
        JSON.stringify({
          investment: {
            company_attributes: company,
          },
        })
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }

  static deleteInvestment(id) {
    return axiosClient
      .delete(`/api/v1/investments/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }

  static postTwitterCallback(data) {
    return axiosClient
      .post('/api/v1/oauth/twitter/callback', data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }

  static deleteTwitterLink() {
    return axiosClient
      .delete('/api/v1/oauth', {
        data: { provider: 'twitter' },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response.data;
      });
  }
}

export default Api;
